export default "__VITE_ASSET__Br8xtaAn__"